import selectHtml from './select.html';

class ConfiguratorSelectComponent {
    constructor($scope) {
        'ngInject';

        this.isOpen = false;
        this.$scope = $scope;
    }

    open() {
        this.isOpen = true;
    }

    close() {
        this.isOpen = false;
    }

    setActive(item) {
        if (this.isNotAvailable(item))
            return false;

        this.close();
        
        if (this.onSelect && typeof this.onSelect === 'function') {
            const isSuccess = this.onSelect({value: item});
            
            if (isSuccess) this.active = item;
        } else {
            this.active = item;
        }
    }

    isNotAvailable(item) {
        if (!this.available) return false;

        for (const type of this.available) {
            if (type.name == item.name) return false;
        }

        return true;
    }

    get availableItems() {
        if (!this.items || this.items.length < 1) return [];

        return this.items.filter(item => item.available);
    }
}

let configuratorSelectComponent = {
    bindings: {
        'items': '<',
        'active': '<',
        'available': '<',
        'notAvailableInfo': '<',
        'onSelect': '&'
    },
    template: selectHtml,
    controller: ConfiguratorSelectComponent
};

export default configuratorSelectComponent;